export function sprintf(template, values) {
    if (typeof template === 'string') {
        return template?.replace(/{(\w+)}/g, (match, key) => values[key] || match);
    }
    return ''
}